import * as CL from '@design-system/component-library';
import { saveMsg, t } from '../../../common/i18n/index.js';
import { DeviceSelectionCountsCoCo } from './DeviceSelectionCountsCoCo.js';
import type { DeviceSelectionCategoryCountCoCo } from '../../../common/utils/deviceSelectionCategoryUtilsCoCo.js';

import './DeviceSelectionFooterCoCo.scss';

export interface DeviceSelectionFooterCoCoProps {
  categoryCounts: DeviceSelectionCategoryCountCoCo[];
  saveDisabled?: boolean;
  total?: number;
}

// Save button submits the surrounding form, so the footer must be rendered inside it
export const DeviceSelectionFooterCoCo = ({
  categoryCounts,
  saveDisabled = false,
  total,
}: DeviceSelectionFooterCoCoProps) => (
  <footer className="of-device-selection-footer-coco">
    <div className="of-device-selection-footer-coco__content">
      <div className="of-device-selection-footer-coco__summary">
        <DeviceSelectionCountsCoCo
          blockClassName="of-device-selection-footer-coco"
          categoryCounts={categoryCounts}
          total={total ?? categoryCounts.reduce((sum, { count }) => sum + count, 0)}
        />
      </div>
      <CL.Button type="submit" color="primary" size="l" disabled={saveDisabled}>
        {t.NIWE(saveMsg)}
      </CL.Button>
    </div>
  </footer>
);
